import React from 'react';
import Hero from '../components/Hero';
import Card from '../components/Card';
import { Smartphone, Laptop, Heart, Sprout, Calendar, Music, ShieldCheck, Zap, Award } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import './Insurance.css';

const Others = () => {
    const { t } = useLanguage();

    const otherPlans = [
        { key: 'ft_oth_mobile', icon: Smartphone, desc: 'Highest coverage for accidental screen damage and theft for your devices.' },
        { key: 'ft_oth_gadget', icon: Laptop, desc: 'Coverage for expensive electronics like DSLRs, iPads, and gaming rigs.' },
        { key: 'ft_oth_pet', icon: Heart, desc: 'Medical insurance for your beloved furry friends for illness and accidents.' },
        { key: 'ft_oth_crop', icon: Sprout, desc: 'Dedicated farmer insurance plans covering weather and pest risks.' },
        { key: 'ft_oth_event', icon: Calendar, desc: 'Public liability and venue insurance for corporate events and gatherings.' },
        { key: 'ft_oth_wed', icon: Music, desc: 'Secure your special day against venue cancellation and jewelry theft.' },
    ];

    return (
        <div className="insurance-page">
            <Hero 
                title={t('ft_others')}
                subtitle="From your smartphone to your pet, and from your pets to your wedding day — we protect every bit of your lifestyle."
                bgGradient={true}
                image="/assets/others-hero.png"
            />

            <section className="section-padding container">
                <div className="text-center mb-60">
                    <h2 className="section-title">Specialized Protection</h2>
                    <p className="section-subtitle">Diverse insurance solutions designed for your unique assets and life events.</p>
                </div>
                
                <div className="grid grid-3">
                    {otherPlans.map((plan, i) => (
                        <Card 
                            key={i}
                            title={t(plan.key)}
                            description={plan.desc}
                            icon={plan.icon}
                            link="/contact"
                        />
                    ))}
                </div>
            </section>

            <section className="features-grid section-padding" style={{ background: '#F8F9FA' }}>
                <div className="container">
                    <div className="text-center mb-60">
                        <h2 className="section-title">Why Specialized Insurance?</h2>
                    </div>
                    <div className="grid grid-2">
                        <div className="feature-item">
                            <Smartphone className="feature-icon" />
                            <h4>Smart Protection</h4>
                            <p>Gadget repairs with genuine parts and direct home pickup-drop services.</p>
                        </div>
                        <div className="feature-item">
                            <Zap className="feature-icon" />
                            <h4>Theft Coverage</h4>
                            <p>Global protection against robbery and burglary for your high-value portable assets.</p>
                        </div>
                        <div className="feature-item">
                            <Heart className="feature-icon" />
                            <h4>Pet Wellbeing</h4>
                            <p>Emergency medical cover for cats and dogs with zero breed discrimination.</p>
                        </div>
                        <div className="feature-item">
                            <Award className="feature-icon" />
                            <h4>Peaceful Events</h4>
                            <p>Cover for non-refundable advances and public liabilities at your event venue.</p>
                        </div>
                    </div>
                </div>
            </section>

            <div className="container text-center section-padding">
                <div className="cta-box glass">
                    <h3>Get Personalized Support</h3>
                    <p>Speak to our specialists about your unique insurance requirements today.</p>
                    <button className="btn btn-primary" onClick={() => window.location.href='/contact'}>Talk to Specialist</button>
                </div>
            </div>
        </div>
    );
};

export default Others;
